import { render, staticRenderFns } from "./BookingItemReview.vue?vue&type=template&id=50ceb7ad&scoped=true&"
import script from "./BookingItemReview.vue?vue&type=script&lang=js&"
export * from "./BookingItemReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ceb7ad",
  null
  
)

export default component.exports